<template>
  <div>
    <md-card>
      <md-card-header>
        <h4 class="card-title">Filtros</h4>
      </md-card-header>
      <md-card-content>
        <div class="md-layout md-gutter">
          <div
            class="md-layout-item md-layout md-medium-size-40 md-small-size-40 md-xsmall-size-100"
          >
            <div class="md-layout-item md-layout md-size-100">
              <md-field>
                <label for="customerS">Concesionaria</label>
                <md-select v-model="customerS" name="customerS" id="customerS">
                  <md-option :value="0">Sin Filtro</md-option>
                  <md-option :value="c.id" v-for="c in mCustomers" :key="c.id">{{c.name}}</md-option>
                </md-select>
              </md-field>
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import { Slider, Collapse } from "@/components";
import dataService from "../../../services/catalog";

export default {
  components: {
    Slider,
    Collapse,
  },
  data() {
    return {
      responsive: false,
      // selected
      customerS: 0,
      // metadatas
      mCustomers: [],

      filterFunctions: [],
    };
  },
  props: {
    datasIn: Array,
  },
  methods: {
    registerFilter(filterFunction) {
      this.filterFunctions.push(filterFunction);
    },

    filterF(item) {
      for (let i in this.filterFunctions) {
        if (!this.filterFunctions[i](item)) {
          return false;
        }
      }
      return true;
    },

    consultMetas(ruta, asign, arg) {
      // Make query for metaDatas
      dataService.fetch(ruta, { id: arg, noStore: true }).then((res) => {
        this[asign] = res;
      });
    },

    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
  },
  mounted() {
    this.registerFilter((element) => {
      return !this.customerS ? true : element.customer === this.customerS;
    });

    // get metadatas
    this.consultMetas("customer", "mCustomers");

    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  watch: {
    datasOut: function () {
      this.$emit("filtered", this.datasOut);
    },
  },
  computed: {
    datasOut: function () {
      return this.datasIn.filter(this.filterF);
    },
  },
};
</script>

<style lang="scss" scoped>
.md-card-content:last-of-type {
  padding-bottom: 0px;
}

.md-card .md-card-content {
  padding: 0px 15px;
  line-height: 1.75em;
  position: relative;
}

.md-field.md-focused label,
.md-field.md-field.md-has-value label {
  top: -1rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/Catalogs/Highway/Filter.vue